import React, { ReactElement } from "react";
import { Link } from "gatsby";
import NavItem from "../NavItem";
import {
  getCategoryMenuHref,
  isCategoryNavItemActive,
  isV2CategoryMenuLink,
} from "../../utils/category-navigation";

interface CategoryNavLinkProps {
  categoryName: string;
  currentPageName: string;
  pathname: string;
}

export default ({
  categoryName,
  currentPageName,
  pathname,
}: CategoryNavLinkProps): ReactElement => {
  const href = getCategoryMenuHref(categoryName);
  const active = isCategoryNavItemActive(
    categoryName,
    currentPageName,
    pathname
  );

  const item = <NavItem active={active}>{categoryName}</NavItem>;

  if (isV2CategoryMenuLink(categoryName)) {
    return <a href={href}>{item}</a>;
  }

  return <Link to={href}>{item}</Link>;
};
